import * as yup from 'yup';
import withRouter from '@utils/wrappers/WithRouter';

import DistributionListForm from './DistributionListForm';
import CrudPage from '@modules/cruds/CrudPage';
import { defaultConfigComponent } from './DistributionLists';

const distListSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  channel: yup.object().required().label('Channel'),
});

const DistributionListPage = props => {
  return (
    <CrudPage
      key={'distListPage'}
      configComponent={defaultConfigComponent}
      form={DistributionListForm}
      validationSchema={distListSchema}
    />
  );
};

export default withRouter(DistributionListPage);
